<template>
    <modal name="channels-modal"
           :min-width="600"
           height="auto"
           :adaptive="true"
           :scrollable="true"
           @before-open="beforeOpen">


        <table class="md table table-striped">
            <thead>
            <tr>
                <th>ID</th>
                <th>Name</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <draggable v-model="channels" :element="'tbody'" :list="channels">
                <tr v-for="(channel, index) in channels" :key="index" :class="{editing: channel === editedChannel}">
                    <td class="md-td md-td-w">{{ channel.id }}</td>
                    <td class="md-view md-td md-channel-name">{{ channel.name }}</td>
                    <td class="md-edit md-td">
                        <input type="text" v-model="channel.name"/>
                    </td>

                    <td class="text-right md-td">
                        <a class="md-edit-text md-view" @click.prevent="editChannel(channel)">Редактировать</a>
                        <a class="md-edit-text md-edit" @click="closeEdit">Сохранить</a>
                    </td>
                    <td class="md-td md-td-w">
                        <svg-icon icon="x_admin-01" @click.native="deleteChannel(index)"/>
                    </td>
                </tr>
            </draggable>
        </table>

        <form @submit.prevent="addChannel" class="md-channel-form">
            <input type="text" required class="input-modal" v-model="model.name"/>
            <button type="submit" class="md-add-btn md-edit-text">Добавить</button>
        </form>

        <div class="md-footer">
            <button type="submit" class="md-add-btn md-edit-text" @click="saveChanges">Применить изменения</button>
        </div>
    </modal>
</template>

<script>

  import SvgIcon from '../layout/SvgIcon'
  import bAlert from 'bootstrap-vue/es/components/alert/alert'
  import Draggable from 'vuedraggable'

  export default {
    components: {
      SvgIcon,
      Draggable
    },

    data () {
      return {
        channels: null,
        model: {},
        editedChannel: null,
        list: null
      }
    },

    methods: {

      beforeOpen (event) {
        this.channels = event.params.channels
      },

      hide () {
        this.$modal.hide('channels-modal')
      },

      editChannel () {

      },

      deleteChannel (index) {
        if (confirm('Вы действительно хотите удалить этот поток?\nВсе треки из этого потока будут так же удалены!')) {
          this.channels.splice(index, 1)
        }
      },

      addChannel () {
        this.channels.push({name: this.model.name})
        this.model.name = ''
      },

      editChannel (channel) {
        this.editedChannel = channel
      },

      closeEdit () {
        this.editedChannel = null
      },

      saveChanges () {

        this.$http.post('/api/channels/update', {
          channels: this.channels
        })
          .then(response => {
            location.reload()
          })

      }
    }
  }
</script>
<style>

    input.input-modal[type="text"] {
        border: 2px solid #C8C8C8;
        border-radius: 4px;
    }

    button.md-add-btn {
        border: none;
        padding: 0;
        background: none;
        outline: none;
    }

    .md-channel-form {
        width: 50%;
        margin: auto;
    }

    .md-edit {
        display: none;
        height: 100%;
    }

    .editing .md-edit {
        display: block;
    }

    .editing .md-view {
        display: none;
    }
    .md > tbody > tr > td{
         vertical-align: middle;
     }

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/modals/CreateChannelModal.vue